<div class="flex w-full flex-col gap-2" *transloco="let t">
  <div
    class="flex w-full items-center gap-2 max-lg:flex-col max-lg:items-start"
  >
    <span class="shrink-0 text-sm font-semibold">
      {{
        t('portal.courseSettings.topicAreaSettings.variables.' + variableName())
      }}
    </span>
    @if (customizedVariable()) {
      <span
        class="flex h-5 w-full items-center justify-between text-sm font-semibold"
      >
        <app-badge
          class="flex"
          [text]="t('portal.courseSettings.customValue')"
          [type]="'customized-variable'"
        >
        </app-badge>
        <app-reset-text-button
          (resetClick)="onResetToNull()"
        ></app-reset-text-button>
      </span>
    } @else if (hasStandardValue()) {
      <span
        class="flex h-5 w-full items-center justify-between text-sm font-semibold"
      >
        <app-badge
          class="flex"
          [text]="t('portal.courseSettings.standardValue')"
          [type]="'notification'"
        >
        </app-badge>
      </span>
    }
  </div>
  <div
    class="flex w-full flex-row gap-4 max-xl:max-w-[475px] max-xl:flex-col max-xl:justify-center max-xl:gap-2"
  >
    <app-text-area
      class="flex-1"
      [placeholder]="placeholderValue(languageCodeDE)()"
      [language]="languageCodeDE"
      [name]="variableName()"
      [valueSignal]="getVariableSignal(languageCodeDE)"
      [hasTranslation]="hasTranslation()"
      [maxLength]="maxLength()"
    >
    </app-text-area>
    <div
      class="flex flex-col gap-1 max-xl:w-full max-xl:flex-row max-xl:justify-center xl:max-w-[54px]"
    >
      <app-double-icon-button
        leadingIconXL="copy"
        leadingIconSM="copy"
        leadingIconSize="text-sm"
        trailingIconXL="arrow_forward"
        trailingIconSM="arrow_downward"
        trailingIconSize="text-sm"
        (buttonClicked)="copyText(languageCodeDE, languageCodeEN)"
      ></app-double-icon-button>
      <app-double-icon-button
        leadingIconXL="arrow_back"
        leadingIconSM="arrow_upward"
        leadingIconSize="text-sm"
        trailingIconXL="copy"
        trailingIconSM="copy"
        trailingIconSize="text-sm"
        (buttonClicked)="copyText(languageCodeEN, languageCodeDE)"
      ></app-double-icon-button>
    </div>
    <app-text-area
      class="flex-1"
      [placeholder]="placeholderValue(languageCodeEN)()"
      [language]="languageCodeEN"
      [name]="variableName()"
      [valueSignal]="getVariableSignal(languageCodeEN)"
      [hasTranslation]="hasTranslation()"
      [maxLength]="maxLength()"
    >
    </app-text-area>
  </div>
</div>
